import React, { FC } from 'react';
import { TextField } from '@mui/material';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

interface ITextAreaProps<T extends FieldValues> {
    label: string;
    rows?: number;
    placeholder?: string;
    name: Path<T>;
    control: Control<T>;
}

const TextArea = <T extends FieldValues>({ 
    label, 
    rows = 4,
    name,
    control,
    ...rest 
}: ITextAreaProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label={label}
          multiline
          rows={rows}
          variant="outlined"
          fullWidth
          error={!!error}
          helperText={error?.message}
          {...rest}
        />
      )}
    />
  );
}

export default TextArea;
